import { Box, styled, Typography } from '@mui/material';

import { Defaults, GlobalStrings, MobileAppBannerStrings } from '../../constants';
import { isIOS } from '../../lib/util/checkPlatform';

const MobileAppBanner = () => {
  return (
    <Container>
      <StyledRow>
        <Box display={'flex'} alignItems={'center'}>
          <img
            src="/assets/images/logo.svg"
            alt={GlobalStrings.GLOBAL_PROJECT_NAME}
            style={{
              width: '40px',
              height: '40px',
              marginRight: '12px',
              borderRadius: '8px',
            }}
          />
          <Box>
            <Box style={{ fontWeight: 'bold', fontSize: '14px' }}>{GlobalStrings.GLOBAL_PROJECT_NAME}</Box>
          </Box>
        </Box>
        <DownloadApp onClick={() => window.open(isIOS() ? Defaults.APPSTORE_LINK : Defaults.PLAYSTORE_LINK, '_blank')}>
          {MobileAppBannerStrings.DOWNLOAD_APP}
        </DownloadApp>
      </StyledRow>
    </Container>
  );
};

export default MobileAppBanner;

const Container = styled(Box)({
  display: 'block',
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  background: '#000000',
  color: 'white',
  padding: '12px 20px',
  zIndex: 1000,
  boxShadow: '0 -2px 10px rgba(0,0,0,0.2)',
});

const StyledRow = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  maxWidth: '800px',
  margin: '0 auto',
});

const DownloadApp = styled(Typography)({
  background: 'white',
  color: '#000000',
  padding: '8px 16px',
  borderRadius: '20px',
  textDecoration: 'none',
  fontWeight: 'bold',
  fontSize: '14px',
  whiteSpace: 'nowrap',
  cursor: 'pointer',
});
